import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Dropdown, Image, Button, NavDropdown } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Dispatch, RootState, useAppDispatch } from '../../store';
import { getUserData, logOut } from './shared.service';
import { useSelector } from 'react-redux';
import { formatDate } from '../utils/utils';
import {
	getNotificationListHeader,
	readNotification
} from '../../modules/auth/auth.service';

const Header = () => {
	const dispatch: Dispatch = useAppDispatch();
	const navigate = useNavigate();
	const navbar = useLocation();

	const { notificationList, totalNotification, userData, roleandPermission } =
		useSelector((state: RootState) => state.auth);

	const [orderView, setOrderView] = useState<any>([]);

	useEffect(() => {
		console.log();
	}, [notificationList, totalNotification, userData, roleandPermission]);

	// useEffect(() => {
	// 	console.log(totalNotification, notificationList);
	// }, [totalNotification, notificationList]);

	useEffect(() => {
		const data1 = roleandPermission?.find(
			(data: any) => data?.module?.key == 'pending_orders'
		)?.view;
		const data2 = roleandPermission?.find(
			(data: any) => data?.module?.key == 'ongoing_orders'
		)?.view;
		const data3 = roleandPermission?.find(
			(data: any) => data?.module?.key == 'order_history'
		)?.view;

		// console.log(data1, data2, data3);

		setOrderView([data1, data2, data3]);
	}, [roleandPermission]);

	// console.log(orderView, 'order');

	useEffect(() => {
		dispatch(getUserData());
		dispatch(getNotificationListHeader());
	}, []);

	const markAsRead = () => {
		// navigate('');
		const idsArray = notificationList?.map((data: any) => data?.id);
		// const idsArray = notificationlist?.map((data: any) => data?.id);
		dispatch(readNotification(idsArray, 'read'));
	};

	const onNotificationClick = () => {
		navigate('/notifications');
	};

	const onMyProfileClick = () => {
		navigate('/my-profile');
	};

	const onChangePasswordClick = () => {
		navigate('/change-password');
	};

	const onPendingOrdersClick = () => {
		navigate('/pending-orders');
	};
	const onOngoingOrdersClick = () => {
		navigate('/ongoing-orders');
	};

	const onVendorsClick = () => {
		navigate('/vendors');
	};
	const onDriversClick = () => {
		navigate('/drivers');
	};
	const onUsersClick = () => {
		navigate('/users');
	};
	const onOrdersHistoryClick = () => {
		navigate('/orders-history');
	};
	const onReportsClick = () => {
		navigate('/reports');
	};
	const onProductsClick = () => {
		navigate('/products');
	};
	const onMapClick = () => {
		navigate('/map');
	};

	// const onCylinderSizeClick = () => {
	// 	navigate('/cylinder-size');
	// };

	const onLogOutClick = () => {
		dispatch(logOut());
	};

	const activeClass = (url: string) => {
		return navbar.pathname?.includes(url);
	};
	return (
		<Navbar variant='light' expand='lg' className='fixed-top'>
			<Button variant='link' className='navbar-toggle d-inline-block d-lg-none'>
				<Image src='/assets/icons/nav-toggle.svg' alt='Nav Toggle' />
			</Button>
			<Button variant='link' className='p-0'>
				<Link to='/dashboard'>
					<Image src='/assets/images/new-header-logo.svg' width={180} alt='Logo' />
				</Link>
			</Button>
			<div className='mx-auto d-flex'>
				<Link
					to='/dashboard'
					className={activeClass('/dashboard') ? 'active nav-link' : 'nav-link'}
				>
					Dashboard
				</Link>
				{orderView?.some((data: boolean) => data === true) && (
					<NavDropdown
						title='Orders'
						id='basic-nav-dropdown'
						className={`nav-link custom-nav-dropdown ${
							['/pending-orders', '/ongoing-orders', '/orders-history']?.includes(
								navbar.pathname
							)
								? 'active'
								: ''
						} `}
					>
						{orderView[0] && (
							<NavDropdown.Item
								onClick={onPendingOrdersClick}
								className={activeClass('/pending-orders') ? 'active' : ''}
							>
								Pending Orders
							</NavDropdown.Item>
						)}
						{orderView[1] && (
							<NavDropdown.Item
								onClick={onOngoingOrdersClick}
								className={activeClass('/ongoing-orders') ? 'active' : ''}
							>
								Ongoing Orders
							</NavDropdown.Item>
						)}
						{orderView[2] && (
							<NavDropdown.Item
								onClick={onOrdersHistoryClick}
								className={activeClass('/orders-history') ? 'active' : ''}
							>
								Orders History
							</NavDropdown.Item>
						)}
					</NavDropdown>
				)}
				{/* {roleandPermission?.find((data: any) => data?.module?.key == 'map')?.view && (
					<Button
						onClick={onMapClick}
						className={activeClass('/map') ? 'active nav-link' : 'nav-link'}
					>
						Map
					</Button>
				)} */}
				<NavDropdown
					title='Vendors'
					id='basic-nav-dropdown1'
					className='nav-link custom-nav-dropdown vendores-dropdown'
				>
					<NavDropdown.Item as={Link} to='/vendors'>
						Vendors
					</NavDropdown.Item>
					<NavDropdown.Item as={Link} to='/payment'>
						Vendor Payment Settlement
					</NavDropdown.Item>
				</NavDropdown>

				{/* {roleandPermission?.find((data: any) => data?.module?.key == 'vendor')?.view && (
					<Button
						onClick={onVendorsClick}
						className={activeClass('/vendors') ? 'active nav-link' : 'nav-link'}
					>
						Vendors
					</Button>
				)} */}
				{roleandPermission?.find((data: any) => data?.module?.key == 'drivers')?.view && (
					<Button
						onClick={onDriversClick}
						className={activeClass('/drivers') ? 'active nav-link' : 'nav-link'}
					>
						Drivers
					</Button>
				)}
				{roleandPermission?.find((data: any) => data?.module?.key == 'users')?.view && (
					<Button
						onClick={onUsersClick}
						className={activeClass('/users') ? 'active nav-link' : 'nav-link'}
					>
						Customers
					</Button>
				)}
				{roleandPermission?.find((data: any) => data?.module?.key == 'product')?.view && (
					<Button
						onClick={onProductsClick}
						className={activeClass('/product') ? 'active nav-link' : 'nav-link'}
					>
						Products
					</Button>
				)}
				{roleandPermission?.find((data: any) => data?.module?.key == 'reports')?.view && (
					<Button
						onClick={onReportsClick}
						className={activeClass('/reports') ? 'active nav-link' : 'nav-link'}
					>
						Reports
					</Button>
				)}
			</div>
			<Nav className='nav-mobile-fixed order-3 order-lg-4 align-items-center flex-row'>
				<Link to='/my-profile' className='px-2'>
					<i className='icon dripicons-gear toolbar-icon gear-icon text-white'></i>
				</Link>
				{roleandPermission?.find((data: any) => data?.module?.key == 'notifications')
					?.view && (
					<Dropdown className='notification-dropdown ms-2' align='end'>
						<Dropdown.Toggle id='dropdown-split-basic'>
							<i className='icon dripicons-bell toolbar-icon'></i>
							{totalNotification > 0 && (
								<span className='noti-count'>{totalNotification}</span>
							)}
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<div className='dropdown-header'>
								<div className='d-flex align-items-center'>
									<h6 className='font-size-16 mb-0'>Notifications</h6>
									<Dropdown className='mark-dropdown ms-auto' align='end'>
										<Dropdown.Toggle
											id='dropdown-basic'
											className='text-body shadow-none p-0'
										>
											<i className='icon dripicons-dots-3 font-size-22 text-black d-inline-block align-middle'></i>
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item onClick={markAsRead}>
												<div className='d-flex align-items-center'>
													<i className='icon dripicons-checkmark d-flex align-middle me-2'></i>
													Mark as All Read
												</div>
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</div>
							</div>
							<div className='notification-list w-100'>
								{notificationList && notificationList.length > 0 ? (
									notificationList?.map((data: any) => (
										<Dropdown.Item onClick={onNotificationClick} key={data?.id}>
											<div className='m-0' style={{ whiteSpace: 'break-spaces' }}>
												{data?.descriptionEng}
											</div>
											<small className='d-block text-muted mt-1'>
												{formatDate(data?.updatedAt, 'MM:HH A DD/MM/YYYY')}
											</small>
										</Dropdown.Item>
									))
								) : (
									<p style={{ textAlign: 'center' }}>No records found</p>
								)}
							</div>
							<Dropdown.Item
								onClick={onNotificationClick}
								className='text-center view-all'
							>
								View All
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				)}
				<Dropdown className='user-dropdown ms-2' align='end'>
					<Dropdown.Toggle id='dropdown-split-basic-1' className='pe-0'>
						<Image
							src={userData?.profileImage || '/assets/images/profile-img.png'}
							// src={userImg || '/assets/images/profile-img.png'}
							className='profile-img rounded-circle'
							width='35px'
							height='35px'
							alt='Profile'
						/>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<div className='dropdown-header'>
							<div className='d-flex align-items-center'>
								<Image
									src={userData?.profileImage || '/assets/images/profile-img.png'}
									// src={userImg || '/assets/images/profile-img.png'}
									className='profile-img rounded-circle'
									width='40'
									height='40'
									alt='Profile'
								/>
								<div className='ms-3'>
									<h6 className='font-size-16 mb-0'>{`${userData?.firstName ?? ''} ${
										userData?.lastName ?? ''
									}`}</h6>
									<small>{userData?.email}</small>
								</div>
							</div>
						</div>

						<Dropdown.Item onClick={onMyProfileClick}>
							<div className='d-flex align-items-center'>
								<i className='icon dripicons-user dropdown-icon me-2'></i> My Profile
							</div>
						</Dropdown.Item>

						<Dropdown.Item onClick={onChangePasswordClick}>
							<div className='d-flex align-items-center'>
								<i className='icon dripicons-gear dropdown-icon me-2'></i> Change Password
							</div>
						</Dropdown.Item>
						<Dropdown.Item onClick={onLogOutClick}>
							<div className='d-flex align-items-center'>
								<i className='icon dripicons-power dropdown-icon me-2'></i> Logout
							</div>
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</Nav>
		</Navbar>
	);
};

export default Header;
